import { ApolloProvider } from '@apollo/client';
import createClient from './client';

const ConfigurationQueryProvider = ({ children }) => (
	<ApolloProvider client={createClient()}>{children}</ApolloProvider>
);

export { ConfigurationQueryProvider };
